import { Component, Input, Output, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { SustainabilityEntryDialogComponent } from '../sustainability-entry-dialog/sustainability-entry-dialog.component';// adjust path
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from 'app/core/mips/common/services/snackbar.service';
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getCurrentUser } from 'app/core/store/currentUser/user.selectors';
import { ConsultantModel } from 'app/core/mips/common/models/consultant.model';
import { UserService } from '../../../common/services/user.service';
import { LocalStorageService } from 'app/core/mips/common/services/local-storage.service';
import { result } from 'lodash';
import { GridApi } from 'ag-grid-community';
import { SustainabilityEntryService } from 'app/core/mips/common/services/sustainability-entry.service';
import { ChangeDetectorRef } from '@angular/core';
import { Constants } from '../../../common/utilities/constants.config';

@Component({
  selector: 'app-sustainability-entry-table',
  templateUrl: './sustainability-entry-table.component.html',
  styleUrls: ['./sustainability-entry-table.component.scss']
})
export class SustainabilityEntryTableComponent implements OnChanges {
  @Input() rowData: any[] = [];
  @Input() selectedYear: number | null = null;
  @Input() selectedMonth: number | null = null;
  currentUserFirstName: string | null = null;
  @Input() isFlagSubmitted: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() selectedYearMonthPairs: { year: number; month: string }[] = [];
  @Output() rowModified = new EventEmitter<void>();
  isSaveEnabled = false;
  isUnsavedChangesPresent: boolean = false;
  isDeleteButtonEnabled = false;
  gridApi: any;
  isSelectedforDeletion = false;
  @Output() selectedTravelIdsChanged = new EventEmitter<Array<{ travel_id: number, month: number, year: number, mode?: string }>>();
  @Output() rowSelectionChanged = new EventEmitter<boolean>();
  public selectedTravelIds: Array<{ travel_id: number, month: number, year: number, mode?: string }> = [];
  @Output() openDialogFromRow = new EventEmitter<any>();
  @Output() newRowCreated = new EventEmitter<any>();
  @Output() rowEdited = new EventEmitter<any[]>();
  @Output() flagCompletionDeleted = new EventEmitter<any>();
  @Output() monthSelected = new EventEmitter<{ year: number; month: number; monthName: string }>();

  constructor(
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private _snackBarService: SnackbarService,
    private sustainabilityEntryService: SustainabilityEntryService,
    private store: Store
  ) {
    this.store.select(getCurrentUser).subscribe((data) => {
      if (data) {
        this.currentUserFirstName = data.FirstName || null;
      }
    });
  }
  public gridRowData: any[] = [];

  months = [
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' }
  ];
  loadSustainabilityData() {
    if (!this.selectedYearMonthPairs || this.selectedYearMonthPairs.length === 0) {
      this.rowData = [];
      this.updateRowData();
      return;
    }

    const selectedMonths = this.selectedYearMonthPairs.map(pair => {
      const month = pair.month.toString().padStart(2, '0');
      return `${pair.year}-${month}`;
    });

    const loginName = this.currentUserFirstName || '';

    this.sustainabilityEntryService.getSustainabilityData(selectedMonths, loginName).subscribe({
      next: (data) => {
        const dailyData = data.filter(entry => entry.travel_type_desc === 'Daily');
        const rowMap = new Map(this.rowData.map(r => [`${r.year}-${r.month}-${r.travel_id}`, r]));

        for (const row of dailyData) {
          const key = `${row.year}-${row.month}-${row.travel_id}`;
          rowMap.set(key, row);
        }

        this.rowData = Array.from(rowMap.values());
        this.updateRowData();
      },
      error: (error) => {
        console.error('Error fetching sustainability data:', error);
        this.rowData = [];
        this.updateRowData();
      }
    });
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isLoading']) {
      if (this.isLoading) {
        setTimeout(() => this.gridApi?.showLoadingOverlay());
      } else {
        if (!this.gridRowData || this.gridRowData.length === 0) {
          setTimeout(() => this.gridApi?.showNoRowsOverlay());
        } else {
          setTimeout(() => this.gridApi?.hideOverlay());
        }
      }
    }
    if (changes['rowData'] || changes['selectedYear'] || changes['selectedMonth']) {
      this.updateRowData();
    }
  }

  onCellValueChanged(event: any) {
    const row = event.data;
    if (row.status === 'modified') {
      row.status = 'edited';
    } else if (row.status !== 'new') {
      row.status = 'edited';
    }
    this.rowModified.emit();
    this.emitEditedRows();
  }

  disableGridInteractions(): void {
    if (this.gridApi) {
      this.gridApi.deselectAll();
      this.gridApi.setSuppressRowClickSelection(true);
      this.gridApi.setSuppressRowDrag(true);
    }
  }

  getMonthLabel(value: string | null): string {
    const match = this.months.find(q => q.value === value);
    return match ? match.label : '';
  }


  updateRowData(): void {
    if (!this.rowData || this.rowData.length === 0) {
      this.gridRowData = [];
      if (this.gridApi) {
        if (this.isLoading) {
          setTimeout(() => this.gridApi?.showLoadingOverlay());
        } else {
          setTimeout(() => this.gridApi?.showNoRowsOverlay());
        }
      }
      return;
    }
    const groupedRows: { [key: string]: any[] } = {};
    const completionRowsByMonth: { [key: string]: any[] } = {};

    this.rowData.forEach(row => {
      if (row.isBannerRow) return;
      const yearMonth = `${row.year}-${row.month.toString().padStart(2, '0')}`;
      if (row.isCompletionRow) {
        if (!completionRowsByMonth[yearMonth]) {
          completionRowsByMonth[yearMonth] = [];
        }
        completionRowsByMonth[yearMonth].push({
          ...row,
          mode: row.message || row.mode,
          modeLabel: row.message || row.modeLabel,
          yearMonthKey: yearMonth,
          employeeId: row.employeeId || this.currentUserFirstName
        });
        return;
      }
      if (!groupedRows[yearMonth]) {
        groupedRows[yearMonth] = [];
      }
      groupedRows[yearMonth].push({
        ...row,
        employee: this.currentUserFirstName || row.employee,
        yearMonthKey: yearMonth
      });
    });

    const allKeys = Array.from(new Set([...Object.keys(groupedRows), ...Object.keys(completionRowsByMonth)])).sort();

    const processedRows: any[] = [];
    allKeys.forEach(yearMonthKey => {
      const [year, month] = yearMonthKey.split('-');
      const monthName = this.months.find(m => m.value === month)?.label || month;
      processedRows.push({
        isBannerRow: true,
        modeLabel: `${monthName} ${year}`,
        yearMonthKey: yearMonthKey,
        year: parseInt(year, 10),
        month: parseInt(month, 10)
      });
      if (groupedRows[yearMonthKey]) {
        processedRows.push(...groupedRows[yearMonthKey]);
      }
      if (completionRowsByMonth[yearMonthKey]) {
        processedRows.push(...completionRowsByMonth[yearMonthKey]);
      }
    });

    this.gridRowData = processedRows;

    if (this.gridApi) {
      if (this.gridRowData.length === 0) {
        if (this.isLoading) {
          setTimeout(() => this.gridApi?.showLoadingOverlay());
        } else {
          setTimeout(() => this.gridApi?.showNoRowsOverlay());
        }
      } else {
        setTimeout(() => this.gridApi?.hideOverlay());
      }
    }
  }

  onRowDoubleClicked(event: any): void {
    const rowData = event.data;
    if (rowData?.isBannerRow || rowData?.isCompletionRow) return;
    let targetYear: number;
    let targetMonth: number;

    if (rowData?.yearMonthKey) {
      const [yearStr, monthStr] = rowData.yearMonthKey.split('-');
      targetYear = parseInt(yearStr, 10);
      targetMonth = parseInt(monthStr, 10);
    } else if (rowData?.year && rowData?.month) {
      targetYear = rowData.year;
      targetMonth = typeof rowData.month === 'string' ? this.getMonthNumber(rowData.month) : rowData.month;
    } else {
      const currentDate = new Date();
      targetYear = currentDate.getFullYear();
      targetMonth = currentDate.getMonth() + 1;
      console.warn(`[MONTH FIX] Fallback to current date → Year=${targetYear}, Month=${targetMonth}`);
    }

    if (targetMonth < 1 || targetMonth > 12) {
      console.error(`[MONTH FIX ERROR] Invalid month detected: ${targetMonth}`);
      return;
    }
    // Only apply previous month restriction for Daily travel type
    const travelType = rowData?.travel_type_desc;
    const isDailyTravel = !travelType || travelType === 'Daily';

    const isAllowed = !isDailyTravel || this.isEntryEditable(targetYear, targetMonth);

    if (!isAllowed) {
      let message = '';
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();
      const nextMonthDate = new Date(currentYear, currentMonth, 1);
      const nextMonth = nextMonthDate.getMonth() + 1;
      const nextYear = nextMonthDate.getFullYear();
      const isNextMonth = targetYear === nextYear && targetMonth === nextMonth;
      // Check if target is any future month (beyond current)
      const targetIndex = targetYear * 12 + targetMonth;
      const currentIndex = currentYear * 12 + currentMonth;
      if (targetIndex > currentIndex) {
        if (isNextMonth) {
          message = 'Entries cannot be made for next month.';
        } else {
          message = 'Entries cannot be made for future months.';
        }
      } else {
        const previousMonthDate = new Date(currentYear, currentMonth - 2, 1);
        const isPrevMonth = targetYear === previousMonthDate.getFullYear() &&
          targetMonth === previousMonthDate.getMonth() + 1;
        if (isPrevMonth) {
          message = 'Entries for the previous month cannot be added after the 15th of the current month.';
        } else {
          message = 'Entries cannot be made for past months.';
        }
      }
      this._snackBarService.showSnackBar(message, null, 'failure');
      return;
    }

    const isBlankRow = rowData?.isBlank === true || rowData?.status === 'dummy';
    const selectedMonths = this.selectedYearMonthPairs.map(p => {
      const num = Number(p.month);
      return isNaN(num) ? this.getMonthNumber(p.month) : num;
    });

    if (isBlankRow) {
      if (!selectedMonths.includes(targetMonth)) {
        selectedMonths.push(targetMonth);
      }

      const dialogRef = this.dialog.open(SustainabilityEntryDialogComponent, {
        width: '400px',
        data: {
          selectedMonths: selectedMonths,  
          year: targetYear,
          month: targetMonth,
          existingRowData: this.gridRowData
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (!result) return;

        const details = result.transportDetails || [];
        if (details.length === 0 && result.mode) {
          details.push({
            mode: result.mode,
            transport_mode_id: result.transport_mode_id,
            distance: result.distance,
            commutingDays: result.commutingDays
          });
        }

        details.forEach((detail: any) => {
          if (!detail) return;
          const finalYear = detail.year ? Number(detail.year) : targetYear;
          const finalMonth = detail.month ? Number(detail.month) : targetMonth;
          const newRow = {
            travel_id: undefined,
            mode: detail.mode,
            transport_mode_id: detail.transport_mode_id,
            distance: detail.distance,
            commutingDays: detail.commutingDays,
            unit: result.unit || 'KM',
            employee: this.currentUserFirstName,
            status: 'new',
            year: finalYear,
            month: finalMonth,
            yearMonthKey: `${finalYear}-${finalMonth.toString().padStart(2, '0')}`,
            _tempId: 'row_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
          };

          this.isSaveEnabled = true;
          this.isUnsavedChangesPresent = true;
          this.newRowCreated.emit(newRow);
        });
      });

    } else {
      const dialogRef = this.dialog.open(SustainabilityEntryDialogComponent, {
        width: '400px',
        data: {
          travel_id: rowData.travel_id,
          mode: rowData.mode,
          distance: rowData.distance,
          unit: rowData.unit,
          commutingDays: rowData.commutingDays,
          month: rowData.month,
          year: rowData.year,
          isModifiedEntry: rowData.status === 'modified',
          selectedMonths: selectedMonths,
          startStep: 0,
          _tempId: rowData._tempId
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (!result) return;
        const originalRow = rowData;

        const updatedDetail = result.transportDetails?.[0] || {
          mode: result.mode,
          distance: result.distance,
          commutingDays: result.commutingDays
        };

        const isSame =
          originalRow.mode === updatedDetail.mode &&
          Number(originalRow.distance) === Number(updatedDetail.distance) &&
          Number(originalRow.commutingDays) === Number(updatedDetail.commutingDays) &&
          (originalRow.unit || '').toLowerCase() === (result.unit || '').toLowerCase();

        if (isSame) {
          return; // 
        }

        let index = -1;
        if (originalRow._tempId) {
          index = this.gridRowData.findIndex(row => row._tempId === originalRow._tempId);
        } else if (originalRow.travel_id && originalRow.travel_id !== 0) {
          index = this.gridRowData.findIndex(row => row.travel_id === originalRow.travel_id);
        } else {
          index = this.gridRowData.findIndex(row =>
            row === originalRow ||
            (row.mode === originalRow.mode &&
             row.month === originalRow.month &&
             row.year === originalRow.year &&
             (!row.travel_id || row.travel_id === 0))
          );
        }

        if (index !== -1) {
          const newStatus = (this.gridRowData[index].status === 'modified' && (!this.gridRowData[index].travel_id || this.gridRowData[index].travel_id === 0))
            ? 'modified'
            : 'edited';

          this.gridRowData[index] = {
            ...this.gridRowData[index],
            mode: updatedDetail.mode || this.gridRowData[index].mode,
            transport_mode_id: updatedDetail.transport_mode_id || this.gridRowData[index].transport_mode_id,
            distance: updatedDetail.distance ?? this.gridRowData[index].distance,
            commutingDays: updatedDetail.commutingDays ?? this.gridRowData[index].commutingDays,
            month: updatedDetail.month ?? this.gridRowData[index].month,
            year: updatedDetail.year ?? this.gridRowData[index].year,
            unit: result.unit || this.gridRowData[index].unit,
            employee: this.currentUserFirstName,
            status: newStatus
          };

          const updatedRow = this.gridRowData[index];
          try {
            let srcIndex = -1;
            if (updatedRow._tempId) {
              srcIndex = this.rowData.findIndex(r => r._tempId === updatedRow._tempId);
            } else if (updatedRow.travel_id && updatedRow.travel_id !== 0) {
              srcIndex = this.rowData.findIndex(r => r.travel_id === updatedRow.travel_id);
            } else {
              srcIndex = this.rowData.findIndex(r =>
                r === originalRow ||
                (r.mode === originalRow.mode &&
                 r.year === originalRow.year &&
                 r.month === originalRow.month &&
                 (!r.travel_id || r.travel_id === 0))
              );
            }

            if (srcIndex !== -1) {
              this.rowData = this.rowData.map((r, i) => i === srcIndex ? { ...r, ...updatedRow } : r);
            } else {
              this.rowData = [...this.rowData, updatedRow];
            }
          } catch (e) {
            console.warn('[EDIT DEBUG] Failed to sync rowData:', e);
          }

          this.updateRowData();

          if (this.gridApi && typeof this.gridApi.setRowData === 'function') {
            this.gridApi.setRowData(this.gridRowData || []);
          } else if (this.gridApi && typeof this.gridApi.redrawRows === 'function') {
            this.gridApi.redrawRows();
          }

          this.isSaveEnabled = true;
          this.isUnsavedChangesPresent = true;
          this.rowModified.emit();
          this.emitEditedRows();
        }
      });
    }
  }

  private isEntryEditable(year: number, month: number): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const deadline = new Date(year, month, 15);
    deadline.setHours(0, 0, 0, 0);

    return today <= deadline;
  }

  private getMonthNumber(monthName: string): number {
    const monthMap: { [key: string]: number } = {
      'January': 1, 'February': 2, 'March': 3, 'April': 4,
      'May': 5, 'June': 6, 'July': 7, 'August': 8,
      'September': 9, 'October': 10, 'November': 11, 'December': 12
    };
    return monthMap[monthName] || 1;
  }

  emitEditedRows() {
    const edited = (this.gridRowData || []).filter(r => !r.isBannerRow && !r.isBlank && !r.isCompletionRow && (r.status === 'edited' || r.status === 'modified'));
    this.rowEdited.emit(edited);
  }
  onRowDragEnd(event: any): void {
    const draggedData = event.node?.data;
    const targetIndex = event.overIndex;

    if (!draggedData || draggedData.isBannerRow || draggedData.isCompletionRow) return;

    if (draggedData.isBlank) {
      this._snackBarService.showSnackBar(
        Constants.SNACKBAR_MSG_ENTRY_BLANK_ROW,
        '',
        'warning'
      );
      return;
    }

    // Use overNode.data as primary, fall back to gridRowData[overIndex]
    const targetRow = event.overNode?.data || this.gridRowData[targetIndex];
    if (!targetRow || targetRow.isCompletionRow) return;

    let tgtYear = targetRow.year ? Number(targetRow.year) : undefined;
    let tgtMonth = targetRow.month ? Number(targetRow.month) : undefined;

    if ((tgtYear == null || isNaN(tgtYear) || tgtMonth == null || isNaN(tgtMonth)) && targetRow.yearMonthKey) {
      const parts = targetRow.yearMonthKey.split('-');
      if (parts.length >= 2) {
        tgtYear = Number(parts[0]);
        tgtMonth = Number(parts[1]);
      }
    }
    if ((tgtYear == null || isNaN(tgtYear) || tgtMonth == null || isNaN(tgtMonth)) && targetRow.modeLabel) {
      const parts = (targetRow.modeLabel || '').trim().split(' ');
      if (parts.length >= 2) {
        tgtYear = Number(parts[1]);
        const m = this.months.find(mon => mon.label.toLowerCase() === parts[0].toLowerCase());
        tgtMonth = m ? Number(m.value) : undefined;
      }
    }

    if (tgtYear == null || isNaN(tgtYear) || tgtMonth == null || isNaN(tgtMonth)) return;

    const dragMonth = Number(draggedData.month);
    const dragYear = Number(draggedData.year);

    const draggedKey = `${dragYear}-${dragMonth.toString().padStart(2, '0')}`;
    const targetKey = `${tgtYear}-${tgtMonth.toString().padStart(2, '0')}`;
    const isSameMonth = (draggedKey === targetKey);

    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    const tgtIndex = tgtYear * 12 + tgtMonth;
    const curIndex = currentYear * 12 + currentMonth;

    if (isSameMonth) {
      if (tgtIndex > curIndex) {
        this._snackBarService.showSnackBar('Entries can be made only after 1st of each month.', null, 'failure');
        return;
      }
      if (!this.isEntryEditable(tgtYear, tgtMonth)) {
        this._snackBarService.showSnackBar(
          'Entries for the previous month cannot be edited after the 15th of the current month.',
          null,
          'failure'
        );
        return;
      }
    } else {
      let prevMonth = currentMonth - 1;
      let prevYear = currentYear;
      if (prevMonth === 0) {
        prevMonth = 12;
        prevYear -= 1;
      }

      const isDragFromPrevMonth = (dragYear === prevYear && dragMonth === prevMonth);
      const isTargetCurrentMonth = (tgtYear === currentYear && tgtMonth === currentMonth);

      if (!isDragFromPrevMonth || !isTargetCurrentMonth) {
        let message = '';
        if (tgtIndex > curIndex) {
          message = 'Entries can be made only after 1st of each month.';
        } else if (!isDragFromPrevMonth && dragYear * 12 + dragMonth >= curIndex) {
          message = 'Drags are only allowed from the previous month to the current month or within the same month.';
        } else {
          message = 'Drags are only allowed from the previous month to the current month or within the same month.';
        }
        this._snackBarService.showSnackBar(message, null, 'failure');
        return;
      }

      const duplicateExists = this.gridRowData.some(row =>
        !row.isBannerRow &&
        (!row.travel_type_desc || row.travel_type_desc === 'Daily') &&
        row.year === tgtYear &&
        row.month === tgtMonth &&
        row.mode?.toLowerCase() === draggedData.mode?.toLowerCase()
      );

      if (duplicateExists) {
        this._snackBarService.showSnackBar(
          `Duplicate Entry Not Allowed`,
          null,
          'failure'
        );
        return;
      }
    }

    const copiedRow = JSON.parse(JSON.stringify(draggedData));
    copiedRow._tempId = 'drag_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    copiedRow.year = tgtYear;
    copiedRow.month = tgtMonth;
    copiedRow.yearMonthKey = `${copiedRow.year}-${copiedRow.month.toString().padStart(2, '0')}`;
    copiedRow.status = 'modified';
    copiedRow.travel_id = 0;

    // Emit the copied row to the parent
    this.newRowCreated.emit(copiedRow);

    this.isUnsavedChangesPresent = true;
    this.isSaveEnabled = true;
  }

  onRowModified() {
    this.isSaveEnabled = true;
    this.rowModified.emit();
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    if (this.isUnsavedChangesPresent) {
      (event as BeforeUnloadEvent).returnValue = Constants.MSG_CONFIRM_DISCARD_CHANGES;
    }
  }

  @HostListener('window:pagehide', ['$event'])
  pageHideHandlerForIos(event: Event) {
    if (this.isUnsavedChangesPresent) {
      (event as BeforeUnloadEvent).returnValue = Constants.MSG_CONFIRM_DISCARD_CHANGES;
    }
  }

  onSelectionChanged(event: any) {
    const selectedRows = event.api.getSelectedRows();

    const focusedCell = event.api.getFocusedCell();
    const lastChangedNode = focusedCell
      ? event.api.getDisplayedRowAtIndex(focusedCell.rowIndex)
      : null;

    if (lastChangedNode && lastChangedNode.data?.isBannerRow) {
      const [monthName, year] = (lastChangedNode.data.modeLabel || '').split(" ");
      const monthValue = this.months.find(m => m.label === monthName)?.value;
      if (monthValue) {
        const yearMonthKey = `${year}-${monthValue}`;
        const isBannerSelected = lastChangedNode.isSelected();

        this.gridApi.forEachNode((node: any) => {
          const isSelectableRow = !node.data.isBannerRow && !node.data.isBlank &&
            (!node.data.isCompletionRow || this.isFlagDeletionAllowed(node.data.year, node.data.month, node.data.yearMonthKey));
          if (node.data?.yearMonthKey === yearMonthKey && isSelectableRow) {
            node.setSelected(isBannerSelected);
          }
        });
      }
    } else if (lastChangedNode && !lastChangedNode.data?.isBannerRow) {
      const yearMonthKey = lastChangedNode.data?.yearMonthKey;
      if (!yearMonthKey) return;
      const [year, month] = yearMonthKey.split('-');

      let allSelected = true;
      let anySelected = false;
      let bannerNode: any = null;

      this.gridApi.forEachNode((node: any) => {
        const isSelectableRow = !node.data.isBannerRow && !node.data.isBlank &&
          (!node.data.isCompletionRow || this.isFlagDeletionAllowed(node.data.year, node.data.month, node.data.yearMonthKey));
        if (node.data?.yearMonthKey === yearMonthKey && isSelectableRow) {
          if (!node.isSelected()) {
            allSelected = false;
          } else {
            anySelected = true;
          }
        }
        if (node.data?.isBannerRow) {
          const monthName = this.months.find(m => m.value === month)?.label || '';
          const expectedLabel = `${monthName} ${year}`;
          if (node.data.modeLabel === expectedLabel) {
            bannerNode = node;
          }
        }
      });

      if (bannerNode) {
        if (allSelected) {
          bannerNode.setSelected(true);
        } else {
          bannerNode.setSelected(false);
        }
      }
    }
    const selectedEntries = event.api
      .getSelectedRows()
      .filter((row: any) => !row.isBannerRow && !row.isBlank)
      .map((row: any) => ({
        travel_id: row.travel_id || 0,
        month: row.month,
        year: row.year,
        mode: row.mode,
        isCompletionRow: !!row.isCompletionRow,
        employeeId: row.employeeId
      }));
    event.api.getSelectedRows().forEach((row: any) => {
    });

    const rawSelected = event.api.getSelectedRows();
    if (rawSelected && rawSelected.length > 0) {
      this.extractAndEmitSelectedMonth(rawSelected[rawSelected.length - 1]);
    }

    this.selectedTravelIds = selectedEntries;
    this.isSelectedforDeletion = selectedEntries.length > 0;
    this.rowSelectionChanged.emit(this.isSelectedforDeletion);
    this.selectedTravelIdsChanged.emit(selectedEntries);
  }

  onRowClicked(event: any): void {
    if (event?.data) {
      this.extractAndEmitSelectedMonth(event.data);
    }
  }

  onCellClicked(event: any): void {
    if (event?.data) {
      this.extractAndEmitSelectedMonth(event.data);
    }
  }

  onCellFocused(event: any): void {
    if (event && event.rowIndex != null && this.gridApi) {
      const node = this.gridApi.getDisplayedRowAtIndex(event.rowIndex);
      if (node?.data) {
        this.extractAndEmitSelectedMonth(node.data);
      }
    }
  }

  private extractAndEmitSelectedMonth(rowData: any): void {
    if (!rowData) return;
    let monthNum: number | null = null;
    let yearNum: number | null = null;

    if (rowData.yearMonthKey) {
      const [y, m] = rowData.yearMonthKey.split('-');
      yearNum = parseInt(y, 10);
      monthNum = parseInt(m, 10);
    } else if (rowData.year && rowData.month) {
      yearNum = Number(rowData.year);
      monthNum = typeof rowData.month === 'string' ? this.getMonthNumber(rowData.month) : Number(rowData.month);
    } else if (rowData.isBannerRow && rowData.modeLabel) {
      const parts = rowData.modeLabel.trim().split(' ');
      if (parts.length >= 2) {
        const monthName = parts[0];
        monthNum = this.getMonthNumber(monthName);
        yearNum = parseInt(parts[1], 10);
      }
    }

    if (monthNum && yearNum && !isNaN(monthNum) && !isNaN(yearNum)) {
      const monthName = this.months.find(m => Number(m.value) === monthNum)?.label || '';
      this.monthSelected.emit({ year: yearNum, month: monthNum, monthName });
    }
  }


  columnDefs = [
    {
      headerName: '',
      field: 'travel_id',
      valueGetter: () => '',
      checkboxSelection: (params) => {
        if (params.data?.isBlank || params.data?.status === 'dummy') return false;
        if (params.data?.isCompletionRow) {
          return this.isFlagDeletionAllowed(params.data?.year, params.data?.month, params.data?.yearMonthKey);
        }
        return true;
      },
      width: 60,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      pinned: 'left',
      rowDrag: params => !params.data?.isBannerRow && !params.data?.isBlank && !params.data?.isCompletionRow
    },
    {
      headerName: 'Mode of Transport',
      field: 'mode',
      cellRenderer: (params: any) => {
        if (params.data?.isBannerRow) {
          return `<div class="banner-text">${params.data.modeLabel}</div>`;
        }
        return `<span>${params.data?.message || params.value}</span>`;
      },
      cellClass: params => params.data?.isBannerRow ? 'banner-cell' : ''
    },
    {
      headerName: 'Unit',
      field: 'unit',
      valueGetter: params => (params.data?.isBannerRow || params.data?.isCompletionRow) ? null : params.data.unit
    },
    {
      headerName: 'Distance',
      field: 'distance',
      valueGetter: params => (params.data?.isBannerRow || params.data?.isCompletionRow) ? null : Number(params.data.transport_mode_id) === 16 ? 0 : params.data.distance,
      cellClass: params => Number(params.data?.transport_mode_id) === 16 ? 'bold-cell work-from-home-distance' : 'bold-cell'
    },
    {
      headerName: 'Commuting Days Per Week',
      field: 'commutingDays',
      valueGetter: params => (params.data?.isBannerRow || params.data?.isCompletionRow) ? null : params.data.commutingDays,
      cellClass: 'bold-cell'
    },
    {
      headerName: 'Employee',
      field: 'employee',
      valueGetter: (params) => {
        if (params.data?.isBannerRow || params.data?.isCompletionRow) return null;
        return this.currentUserFirstName || params.data.employee;
      }
    }
  ];

  isFlagDeletionAllowed(year?: number | string, month?: number | string, yearMonthKey?: string): boolean {
    let y: number | undefined;
    let m: number | undefined;

    if (year != null && month != null) {
      y = Number(year);
      m = typeof month === 'string' && isNaN(Number(month)) ? this.getMonthNumber(month) : Number(month);
    } else if (yearMonthKey) {
      const parts = yearMonthKey.split('-');
      if (parts.length >= 2) {
        y = Number(parts[0]);
        m = Number(parts[1]);
      }
    }

    if (!y || !m || isNaN(y) || isNaN(m) || m < 1 || m > 12) {
      const today = new Date();
      y = today.getFullYear();
      m = today.getMonth() + 1;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Current month flag can be edited/deleted until the 15th of the following month
    const deadline = new Date(y, m, 15);
    deadline.setHours(23, 59, 59, 999);

    return today <= deadline;
  }

  onDeleteCompletionRow(rowData: any): void {
    if (!this.isFlagDeletionAllowed(rowData?.year, rowData?.month, rowData?.yearMonthKey)) {
      this._snackBarService.showSnackBar(
        'Flag completion records cannot be deleted after the 15th of the following month.',
        null,
        'failure'
      );
      return;
    }

    const monthDisplay = rowData.monthName || this.months.find(m => Number(m.value) === Number(rowData.month))?.label || rowData.month;
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the flag completion record for ${monthDisplay} ${rowData.year}?`
    );
    if (!confirmDelete) return;

    this.flagCompletionDeleted.emit(rowData);
  }

  gridOptions = {
    rowSelection: 'multiple',
    suppressRowClickSelection: true,
    groupSelectsChildren: true,
    suppressAggFuncInHeader: true,
    groupDisplayType: 'groupRows',
    animateRows: true,
    isRowSelectable: (rowNode: any) => {
      if (rowNode.data?.isBlank || rowNode.data?.status === 'dummy') return false;
      if (rowNode.data?.isCompletionRow) {
        return this.isFlagDeletionAllowed(rowNode.data?.year, rowNode.data?.month, rowNode.data?.yearMonthKey);
      }
      return true;
    },
    overlayNoRowsTemplate: '<span class="ag-overlay-no-rows-center" style="padding: 20px; font-style: italic; color: #666; font-size: 14px;">No sustainability entries found for the selected month.</span>',
    onSelectionChanged: this.onSelectionChanged.bind(this),
    postSortRows: (params: any) => {
      if (!params || !params.nodes) return;
      const monthGroups: { [key: string]: { banner?: any, rows: any[], completion?: any } } = {};
      const monthOrder: string[] = [];

      for (const node of params.nodes) {
        const data = node.data;
        if (!data) continue;
        let monthKey = data.yearMonthKey || (data.year && data.month ? `${data.year}-${data.month.toString().padStart(2, '0')}` : null);
        if (data.isBannerRow) {
          const parts = (data.modeLabel || '').trim().split(' ');
          if (parts.length >= 2) {
            const mVal = this.months.find(m => m.label.toLowerCase() === parts[0].toLowerCase())?.value || '01';
            monthKey = `${parts[1]}-${mVal}`;
          }
        }
        if (!monthKey) monthKey = 'default';

        if (!monthGroups[monthKey]) {
          monthGroups[monthKey] = { rows: [] };
          monthOrder.push(monthKey);
        }

        if (data.isBannerRow) {
          monthGroups[monthKey].banner = node;
        } else if (data.isCompletionRow) {
          monthGroups[monthKey].completion = node;
        } else {
          monthGroups[monthKey].rows.push(node);
        }
      }

      if (monthOrder.length > 0) {
        const sortedNodes: any[] = [];
        monthOrder.forEach(key => {
          const grp = monthGroups[key];
          if (grp.banner) sortedNodes.push(grp.banner);
          if (grp.rows && grp.rows.length > 0) sortedNodes.push(...grp.rows);
          if (grp.completion) sortedNodes.push(grp.completion);
        });
        if (sortedNodes.length === params.nodes.length) {
          params.nodes.length = 0;
          params.nodes.push(...sortedNodes);
        }
      }
    },
    getRowClass: (params) => {
      if (params.data?.isBannerRow) {
        return 'banner-row';
      }
      if (params.data?.isCompletionRow) {
        return 'highlight-fetched';
      }
      if (params.data?.status === 'new') {
        return 'highlight-new';
      }
      if (params.data?.status === 'edited' || params.data?.status === 'modified') {
        return 'highlight-edited';
      }
      return 'highlight-fetched';
    },
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true
    },
    onRowDragEnd: this.onRowDragEnd.bind(this),
    rowDragEntireRow: true,
    rowDragManaged: false,
    onGridReady: (params: any) => {
      this.gridApi = params.api;
      if (this.isLoading || !this.gridRowData || this.gridRowData.length === 0) {
        setTimeout(() => this.gridApi?.showLoadingOverlay());
      }
    },
    getRowStyle: params => {
      if (params.data?.isBannerRow) {
        return {
          backgroundColor: '#6cc43c',
          color: 'black',
          fontWeight: 'bold'
        };
      }
      if (params.node.group) {
        return {
          backgroundColor: '#72cb36',
          color: 'white',
          fontWeight: 'bold'
        };
      }
      return {};
    }
  };
}
